import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { Select } from 'ui/shared/Select';

export type OwnProps = {
    id: string;
    value: string;
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    disabled: boolean;
};

const RawPositionPicker = ({ id, value, onChange, disabled, t }: OwnProps & TranslateProps) =>
    <Select
        id={ id }
        value={ value }
        onChange={ onChange }
        disabled={ disabled }
    >
        <option value="first">{ t('WC_POSITION_FIRST') }</option>
        <option value="second">{ t('WC_POSITION_SECOND') }</option>
        <option value="third">{ t('WC_POSITION_THIRD') }</option>
        <option value="fourth">{ t('WC_POSITION_FOURTH') }</option>
        <option value="last">{ t('WC_POSITION_LAST') }</option>
    </Select>
;

export const PositionPicker = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('PositionPicker'),
    translate(),
)(RawPositionPicker);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/recurrence/PositionPicker.tsx